import axios from "axios";

class ErrorBoundaryService {
	async log(errorData) {
		return await axios
			.post(`/api/v1/frontend-error`, {
				error_data: errorData,
			})
			.then((response) => response.data);
	}
}

const errorBoundaryService = new ErrorBoundaryService();
export default errorBoundaryService;
